const user = {
  namespaced: true,
  state: {
    userMobile: localStorage.getItem("userMobile") || "",
    userAvatar: localStorage.getItem("userAvatar") || "",
    userOpenid: localStorage.getItem("userOpenid") || "",
    authtoken: localStorage.getItem("authtoken") || ""
  },
  getters: {},
  mutations: {
    setUserMobile(state, data) {
      state.userMobile = data;
      localStorage.setItem("userMobile", data);
    },
    setUserAvatar(state, data) {
      state.userAvatar = data;
      localStorage.setItem("userAvatar", data);
    },
    setUserOpenid(state, data) {
      state.userOpenid = data;
      localStorage.setItem("userOpenid", data);
    },
    setAuthToken(state, data) {
      state.authtoken = data;
      localStorage.setItem("authtoken", data);
    }
  },
  actions: {}
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js